import React, {useEffect, useState} from "react"
import "./Combo.css"

export const Combo = ({array, onChange, placeholder, onClear}) => {


    const [showList, setShowList] = useState(false)
    const [showClose, setShowClose] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [filteredArray, setFilteredArray] = useState(array)

    const inputValue = (e) => {
        setSearchValue(e.target.value)
    }


    useEffect(() => {
        setFilteredArray(array.filter(el => el.name.toLowerCase().includes(searchValue.toLowerCase())))
    },[searchValue])

    return (
          <div id="combo-form-id"
                onClick={(e) =>{
                    setTimeout(() => {
                        setShowList(!showList)
                        setFilteredArray(array)}, 1)

                }}>
              <input
                     className="candidate_data"
                     type="text"
                     placeholder={placeholder}
                     value={searchValue}

                     onChange={(e) => {
                            inputValue(e)
                            setShowClose(true)
                            setShowList(true)}}
              />

              {/*<i className="fa fa-chevron-down"*/}
              {/*   onClick={(e) =>{*/}
              {/*       setTimeout(() => {*/}
              {/*           setShowList(!showList)*/}
              {/*           setShowTooltip(!showTooltip)*/}
              {/*           setFilteredArray(array)}, 1*/}
              {/*       )*/}
              {/*   }}*/}
              {/*/>*/}
              {showClose &&  <div id="close" onClick={(e) => {
                  setTimeout(() => {
                      setSearchValue('');
                      onClear(e);
                      setShowClose(false);}, 1)
              }}>x</div>}
              {showList &&
                  <div className="dropdownList">
                      <div className="dropdownListInner">
                          {filteredArray.map(item =>
                              <li key={item.id} value={item.id}
                                  onClick={(e) => {
                                      setTimeout(() => {
                                          setSearchValue(item.name)
                                          onChange(e)
                                          setShowList(false)
                                          setShowClose(true)}, 1)
                                  }}>
                                  {item.name}
                              </li>)}
                      </div>
                  </div>}
          </div>
    )
}
